<figure class="tt-c-vc-pin" tabindex="-1">
  <a href="" v-bind="$attrs" class="tt-c-vc-pin__item-link tt-u-ignore-default" :title="linkTitle" tabindex="0" rel="nofollow">
    <tt-pinboard-media :media="media"></tt-pinboard-media>
    <div v-if="!isOnMobile" class="tt-c-vc-pin-overlay">
      <span class="tt-c-vc-pin__hover-product-name" v-html="hoverTitle"></span>
      <tt-rating-stars v-if="displayReviewStars" :rating="media.averageRating" class="tt-c-vc-pin__rating tt-c-rating--knockout"></tt-rating-stars>
    </div>
  </a>
  <div v-if="showCaption" class="tt-c-vc-pin__caption-wrap">
    <div class="tt-c-vc-pin__caption">{{caption}}<template v-if="isCaptionTruncated">&hellip;</template></div>
    <span class="tt-c-vc-pin__author">{{author}}<template v-if="isUserNameTruncated">&hellip;</template><template v-if="showDatestamp">,</template></span>
    <span v-if="showDatestamp" class="tt-c-vc-pin__timestamp" v-html="elapsedTime"></span>
  </div>
</figure>
